"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTP = void 0;
const types_1 = require("./types");
const interface_1 = require("../../../../interface");
const trade_utils_lib_1 = require("trade_utils_lib");
const utils_1 = require("../utils");
const utils_2 = require("./utils");
/**
 * 开仓止盈的限制
 */
class OpenTP extends types_1.TPSLLimiter {
    valueOf() {
        var _a, _b, _c, _d;
        const { mode, investInfo, triggerPrice, priceByRateSide, tpslParams } = this.params;
        const rateRes = {
            min: new trade_utils_lib_1.SafeDecimal(0),
            max: new trade_utils_lib_1.SafeDecimal(1000),
        };
        switch (mode) {
            case interface_1.SimpleFutures.TPSLMode.simple_trailing:
                // >=0.1%*杠杆倍数，整数
                return {
                    min: new trade_utils_lib_1.SafeDecimal(0),
                    max: new trade_utils_lib_1.SafeDecimal((_b = (_a = tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit) === null || _a === void 0 ? void 0 : _a.trailing) === null || _b === void 0 ? void 0 : _b.trigger_rate).add(1),
                };
            case interface_1.SimpleFutures.TPSLMode.simple_price:
                if (priceByRateSide && triggerPrice) {
                    // 指定了priceByRateSide代表使用者要求需要根据rate的限制换算出价格的限制
                    const longRes = {
                        min: utils_1.SimpleFuturesTPSLUtils.tpslProfitRateToPrice2(utils_2.SFTPSLLimiterUtils.profitRateToPriceParams(this.params, rateRes.min.toString())),
                        max: utils_1.SimpleFuturesTPSLUtils.tpslProfitRateToPrice2(utils_2.SFTPSLLimiterUtils.profitRateToPriceParams(this.params, rateRes.max.toString())),
                    };
                    return priceByRateSide === interface_1.CustomOrderSide.BUY ? longRes : { min: longRes.max, max: longRes.min };
                }
                return {};
            // // 价格<挂单价格* (1-0.1%) 或 价格 > 挂单价格*(1+0.1%)
            // return {
            //     min: new SafeDecimal(1).sub(0.001).mul(new SafeDecimal(triggerPrice)),
            //     max: new SafeDecimal(1).add(0.001).mul(new SafeDecimal(triggerPrice)),
            //     type: "outside",
            // };
            case interface_1.SimpleFutures.TPSLMode.simple_amount:
                // 按盈亏额=按比例*投资额
                return {
                    min: (_c = rateRes.min) === null || _c === void 0 ? void 0 : _c.mul(new trade_utils_lib_1.SafeDecimal(investInfo.invest)),
                    max: (_d = rateRes.max) === null || _d === void 0 ? void 0 : _d.mul(new trade_utils_lib_1.SafeDecimal(investInfo.invest)),
                };
            case interface_1.SimpleFutures.TPSLMode.simple_rate:
            default:
                return rateRes;
        }
    }
}
exports.OpenTP = OpenTP;
